import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29aed454"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "subtitle",
  style: {"margin-bottom":"0.75rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_3 = { class: "tag is-light is-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "info",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.asset.description), 1),
    (_ctx.asset.created)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Created: " + _toDisplayString(new Date(_ctx.asset.created * 1000).toDateString()), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traits, (trait) => {
      return (_openBlock(), _createElementBlock("p", {
        key: trait.trait_type,
        class: "field"
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(trait.trait_type) + ": " + _toDisplayString(trait.value), 1)
      ]))
    }), 128))
  ], 4))
}